import { APIClient } from "./axiosClient";

const api = new APIClient();

const path = "/agencies";
const path_prepayment = "/prepayments";

const agencyApi = {
  agencyList(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getAgencyDetail(id: string | number, params: any = {}) : Promise<any>  {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },

  createAgency(params: any) {
    return api.post(path, params);
  },

  updateAgency(id: any, params: any) {
    return api.put(`${path}/${id}`, params);
  },

  deleteAgency(id: any) {
    return api.delete(`${path}/${id}`);
  },

  agencyPrepaymentList(params: any): Promise<any> {
    const url = `${path_prepayment}`;
    return api.get(url, params);
  },

  getAgencyPrepaymentDetail(id: string | number, params: any = {}) : Promise<any>  {
    const url = `${path_prepayment}/${id}`;
    return api.get(url, params)
  },

  createAgencyPrepayment(params: any) {
    const url = `${path_prepayment}`;
    return api.post(url, params);
  },

  updateAgencyPrepayment(id: any, params: any) {
    const url = `${path_prepayment}/${id}`;
    return api.put(url, params);
  },

  deleteAgencyPrepayment(id: any) {
    const url = `${path_prepayment}/${id}`;
    return api.delete(url);
  },

  agencyEventStrackingLogs(params: any): Promise<any> {
    const url = `${path}/installs`;
    return api.get(url, params);
  },
};

export default agencyApi;
